export default __webpack_public_path__ + "a73c9b6d2502d30b02414dba4b7e749d.svg";